<template>
  <CRow class="main py-5 mt-3 mb-5">
    <CCol class="py-2">
      <transition name="fade">
        <MenssageAlert :messages="messages" />
      </transition>
      <CRow class>
        <CCol class="h-100">
          <div class="pb-2 h6">
            <h4 class="mt-4">{{ $t('settings.security.title') }}</h4>
          </div>
        </CCol>
      </CRow>

      <!-- EMAIL FALTA COLOCAR EM COMPONENTE -->
      <CCol sm="10" class="mt-5">
        <CRow class>
          <CCol class="h-100" style="padding-left: 0px">
            <h4 class>{{ $t('settings.security.component.email.title') }}</h4>
            <div class="border-line"></div>
          </CCol>
        </CRow>
        <CRow class="mb-4 mt-4">
          <CCol style="padding-left: 0px">
            <CInput
              :label="$t('settings.security.component.email.labelInput')"
              type="email"
              maxlength="255"
              id="email"
              :value.sync="userEmail"
              addLabelClasses="mb-0 required"
              autocomplete="off"
            />
          </CCol>
          <CCol>
            <CButton
              type="button"
              class="btn btn-primary text-uppercase mt-md-4 px-5"
              style="padding: 12px 0px"
              @click="sendEmailToken"
              :class="userButtonValidate ? 'disabled' : false"
              >{{ $t('settings.security.component.email.button.validade') }}</CButton
            >
          </CCol>
        </CRow>
        <transition name="fade" v-if="confirmEmailPopUp">
          <div class="dataTable__popUp popUp" style="margin-top: -10px; margin-left: -15px">
            <div class="popUp__body shadow-sm">
              <div class="confirmationDelete">
                <div class="confirmationDelete__header">
                  <p class="confirmationDelete__title font-weight-semi-bold mb-1">
                    {{ $t('settings.security.component.email.popup.title') }}
                    <br />
                    {{ $t('settings.security.component.email.popup.text') }}
                  </p>
                  <p style="color: #b0b0b0">
                    {{ $t('settings.security.component.email.popup.question') }}
                    <br />
                    <span @click="validationCode" style="text-decoration: underline">{{ $t('settings.security.component.email.popup.text2') }} </span>
                  </p>
                </div>
                <div class="confirmationDelete__body mb-4">
                  <input type="text" class="form-control" v-model="validationCode" />
                </div>
                <div class="confirmationDelete__footer">
                  <div class="confirmationDelete__actions">
                    <CButton class="confirmationDelete__btn btn btn-primary" @click="updateUserEmail">{{
                      $t('settings.security.component.email.popup.confirm')
                    }}</CButton>
                    <CButton class="confirmationDelete__btn" @click="closeConfirmEmailPopUp" type="link">
                      {{ $t('settings.security.component.email.popup.cancel') }}</CButton
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </CCol>

      <Password :messages="messages" @passwordChanged="passwordChanged" />

      <!-- TELEFONE FALTA COLOCAR EM COMPONENTE -->
      <CCol sm="10" class="mt-5" style="padding-left: 0px">
        <CRow class>
          <CCol class="h-100">
            <h4 class>
              {{ $t('settings.security.component.phoneNumber.title') }}
            </h4>
            <div class="border-line"></div>
          </CCol>
        </CRow>
        <CRow :gutters="false">
          <CCol sm="12" class="mt-2">
            <label for="number" class="label-custom required mt-1">
              {{ $t('settings.security.component.phoneNumber.label') }}
            </label>
          </CCol>
          <CCol sm="12">
            <CRow sm="12" class="d-flex" :gutters="false">
              <CCol sm="3" class="mr-1">
                <v-select
                  class="mb-0 no-close"
                  :options="optionsCountries"
                  v-model="$v.countrySelected.$model"
                  :value.sync="$v.countrySelected.$model"
                  :invalidFeedback="$t('settings.security.component.phoneNumber.invalidFeedback')"
                  :isValid="checkIfValid('countrySelected')"
                  id="countrySelected"
                  :placeholder="$t('general.input.placeholder.country-code')"
                  :class="{ 'is-invalid': $v.countrySelected.$error }"
                >
                  <template #selected-option="{ label, flag }">
                    <div class="d-flex align-items-center">
                      <img :src="flag" alt width="25" />
                      <span class="ml-2">{{ label }}</span>
                    </div>
                  </template>
                  <template v-slot:option="option">
                    <img :src="option.flag" width="20" height="auto" />
                    {{ option.label }}
                  </template>
                </v-select>
                <div class="invalid-feedback" v-if="$v.countrySelected.$error">
                  {{ $t('settings.security.component.phoneNumber.invalidFeedback') }}
                </div>
              </CCol>
              <CCol sm="4">
                <CInput
                  type="text"
                  name="phoneNumber"
                  id="phoneNumber"
                  addInputClasses="pr-2"
                  maxlength="15"
                  :value.sync="$v.userPhone.$model"
                  :invalidFeedback="$t('settings.security.component.phoneNumber.invalidFeedback')"
                  :isValid="checkIfValid('userPhone')"
                  @keypress="isNumber($event)"
                />
              </CCol>
              <CCol sm="3">
                <CButton
                  type="button"
                  class="btn btn-primary text-uppercase px-5"
                  style="padding: 12px 0px; margin-left: 15px"
                  @click="sendSMSToken"
                  :disabled="userButtonSMSValidate"
                  >{{ $t('settings.security.component.phoneNumber.button.validade') }}</CButton
                >
              </CCol>
            </CRow>
            <transition name="fade" v-if="confirmSMSPopUp">
              <div class="dataTable__popUp popUp" style="margin-top: -10px">
                <div class="popUp__body shadow-sm">
                  <div class="confirmationDelete">
                    <div class="confirmationDelete__header">
                      <p class="confirmationDelete__title font-weight-semi-bold mb-1">
                        {{ $t('settings.security.component.phoneNumber.popup.title') }}
                        <br />
                        {{ $t('settings.security.component.phoneNumber.popup.text') }}
                      </p>
                      <p style="color: #b0b0b0">
                        {{ $t('settings.security.component.phoneNumber.popup.questions') }}
                        <br />
                        <span @click="sendSMSToken" style="text-decoration: underline">
                          {{ $t('settings.security.component.phoneNumber.popup.text2') }}
                        </span>
                      </p>
                    </div>
                    <div class="confirmationDelete__body mb-4">
                      <input type="text" class="form-control" v-model="validationCodeSMS" />
                    </div>
                    <div class="confirmationDelete__footer">
                      <div class="confirmationDelete__actions">
                        <CButton class="confirmationDelete__btn btn btn-primary" @click="saveConfirmSMSPopUp">{{
                          $t('settings.security.component.phoneNumber.popup.button.confirm')
                        }}</CButton>
                        <CButton class="confirmationDelete__btn" @click="closeConfirmSMSPopUp" type="link">
                          {{ $t('settings.security.component.phoneNumber.popup.button.cancel') }}
                        </CButton>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </transition>
          </CCol>
        </CRow>
      </CCol>

      <!-- DELETE ACCOUNT FALTA COLOCAR EM COMPONENTE -->
      <CCol sm="10" class="mt-5" style="padding-left: 0px; margin-left: -10px">
        <CRow class>
          <CCol class="h-100" style="padding-left: 30px">
            <h4 class>
              {{ $t('settings.security.component.removeAccount') }}
            </h4>
            <div class="border-line"></div>
          </CCol>
        </CRow>
        <CRow class="mb-4 mt-4">
          <CCol style="padding-left: 30px">
            <CButton
              type="button"
              class="btn btn-primary text-uppercase px-5"
              style="padding: 12px 0px"
              @click="openConfirmDeleteUserPopUp"
              :class="userButtonDeleteAccount ? 'disabled' : false"
            >
              {{ $t('settings.security.component.button.delete') }}
            </CButton>
          </CCol>
        </CRow>
        <transition name="fade" v-if="confirmDeleteUserPopUp">
          <div class="dataTable__popUp popUp" style="margin-top: 10px; margin-left: 15px">
            <div class="popUp__body shadow-sm">
              <div class="confirmationDelete">
                <div class="confirmationDelete__header">
                  <p class="confirmationDelete__title font-weight-semi-bold mb-1">
                    {{ $t('settings.security.component.phoneNumber.removeAccount.popup.title') }}
                    <br />
                    {{ $t('settings.security.component.phoneNumber.removeAccount.popup.questions') }}
                  </p>
                </div>
                <div class="confirmationDelete__footer">
                  <div class="confirmationDelete__actions">
                    <CButton class="confirmationDelete__btn btn btn-primary" @click="openDoubleConfirmDeleteUserPopUp">{{
                      $t('settings.security.component.phoneNumber.removeAccount.popup.yes')
                    }}</CButton>
                    <CButton class="confirmationDelete__btn" @click="closeConfirmDeleteUserPopUp" type="link">{{
                      $t('settings.security.component.phoneNumber.removeAccount.popup.no')
                    }}</CButton>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>
        <transition name="fade" v-if="doubleConfirmDeleteUserPopUp">
          <div class="dataTable__popUp popUp" style="margin-top: 10px; margin-left: 400px">
            <div class="popUp__body shadow-sm">
              <div class="confirmationDelete">
                <div class="confirmationDelete__header">
                  <p class="confirmationDelete__title font-weight-semi-bold mb-1">
                    {{ $t('settings.security.component.phoneNumber.removeAccount.popup.title2') }}
                  </p>
                </div>
                <div class="confirmationDelete__body mb-4">
                  <input @keyup="enableDeleteAccountButton" type="text" class="form-control" v-model="confirmDeleteAccountText" />
                </div>
                <div class="confirmationDelete__footer">
                  <div class="confirmationDelete__actions">
                    <CButton
                      class="confirmationDelete__btn btn btn-primary"
                      @click="disableUser"
                      :class="userButtonDoubleConfirmDeleteAccount ? 'disabled' : false"
                      >{{ $t('settings.security.component.phoneNumber.removeAccount.popup.confirm') }}</CButton
                    >
                    <CButton class="confirmationDelete__btn" @click="closeAccountDeleteUserProcess" type="link">{{
                      $t('settings.security.component.phoneNumber.removeAccount.popup.cancel')
                    }}</CButton>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </CCol>
    </CCol>
  </CRow>
</template>

<script>
import Password from './Password'
import MenssageAlert from '@/components/MenssageAlert'
import 'vue-advanced-cropper/dist/style.css'
import vSelect from 'vue-select'
import services from '../security-services'
import { CallingCodeMoreFlag } from '@/utils/countriesUtils.js'
import { required } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'
import { handleErrorCode } from '@/utils/errorHandling.js'

export default {
  components: {
    Password,
    MenssageAlert,
    vSelect,
  },

  data() {
    return {
      messages: [],
      user: {},
      confirmEmailPopUp: false,
      confirmSMSPopUp: false,
      confirmDeleteUserPopUp: false,
      doubleConfirmDeleteUserPopUp: false,
      currentAlertCounter: 5,
      alertMessage: '',
      userID: this.$store.state.auth.user.id,
      userEmail: null, //sessionStorage.userEmail || this.$store.state.auth.user.email,
      userPhoneSentToken: '',
      userButtonValidate: false,
      userButtonSMSValidate: false,
      userButtonDeleteAccount: false,
      userButtonDoubleConfirmDeleteAccount: true,
      validationCode: null,
      validationCodeSMS: null,
      userPhone: null,
      countrySelected: null,
      confirmDeleteAccountText: null,
    }
  },

  mixins: [validationMixin],
  validations: {
    userPhone: {
      required,
    },
    countrySelected: {
      required,
    },
  },

  methods: {
    checkIfValid(fieldName) {
      const field = this.$v[fieldName]

      if (!field.$dirty) {
        return null
      }
      return !(field.$invalid || null)
    },

    passwordChanged(messages) {
      this.messages = []
      this.messages.push(messages)
      this.scrollTop()
    },

    sendEmailToken() {
      this.messages = []

      let body = {
        email: this.userEmail,
      }
      this.userButtonValidate = true
      this.userPhoneSentToken = this.userEmail
      services
        .sendTokenToChangeEmail(this.userID, body)
        .then(() => {
          this.messages.push({
            status: 'success',
            text: this.$t('settings.security.message.success.token-email-provided'),
          })
          this.scrollTop()

          this.confirmEmailPopUp = true
        })
        .catch(() => {
          this.messages.push({
            status: 'danger',
            text: this.$t('settings.security.message.danger.email-already'),
          })
          this.userButtonValidate = false
        })
    },

    updateUserEmail() {
      this.messages = []
      let body = {
        email: this.userPhoneSentToken,
        validationCode: this.validationCode,
      }

      services
        .updateUserEmail(this.userID, body)
        .then(() => {
          this.confirmEmailPopUp = true
          this.messages.push({
            status: 'success',
            text: this.$t('settings.security.message.sucess.update-successfully'),
          })

          this.confirmEmailPopUp = false
          this.userButtonValidate = false
          this.userEmail = this.userPhoneSentToken
          sessionStorage.userEmail = this.userEmail
        })
        .catch(() => {
          this.messages.push({
            status: 'danger',
            text: this.$t('settings.security.message.sucess.request-failed'),
          })
        })
        .finally(() => {
          this.scrollTop()
        })
    },

    closeConfirmEmailPopUp() {
      this.confirmEmailPopUp = false
      this.userButtonValidate = false
    },

    openAlertMessage(alertClass, alertMessage) {
      this.currentAlertCounter = 5
      this.alertClass = alertClass
      this.alertMessage = alertMessage
    },

    scrollTop() {
      setTimeout(() => {
        window.scrollTo(0, 0)
      }, 20)
    },

    isNumber(evt) {
      evt = evt ? evt : window.event
      var charCode = evt.which ? evt.which : evt.keyCode
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },

    sendSMSToken() {
      this.messages = []

      this.$v.$touch()

      if (!this.isValid) {
        return
      }

      this.confirmSMSPopUp = false
      this.userButtonSMSValidate = true

      let body = {
        phoneCountryIndicator: this.countrySelected.value,
        phoneNumber: this.userPhone,
      }

      services
        .sendTokenToChangePhone(this.userID, body)
        .then(() => {
          this.confirmSMSPopUp = true
          this.userPhoneCountryIndicatorSentToken = this.phoneCountryIndicator
          this.userPhoneSentToken = this.userPhone
        })
        .catch((error) => {
          this.messages.push({
            status: 'danger',
            text: handleErrorCode(error.response.data.errorCode),
          })
          this.scrollTop()
          this.userButtonValidate = false
        })
        .finally(() => {
          this.userButtonSMSValidate = false
        })
    },

    closeConfirmSMSPopUp() {
      this.confirmSMSPopUp = false
      this.userButtonSMSValidate = false
    },

    saveConfirmSMSPopUp() {
      this.messages = []
      services
        .updateUserPhone(this.userID, {
          phoneCountryIndicator: this.countrySelected.value,
          phoneNumber: this.userPhone,
          validationCode: this.validationCodeSMS,
        })
        .then(() => {
          this.messages.push({
            status: 'success',
            text: this.$t('settings.security.message.sucess.update-phone'),
          })
          this.scrollTop()
          this.userPhone = ''
          this.countrySelected = null
          this.$v.$reset()
        })
        .catch((error) => {
          this.messages.push({
            status: 'danger',
            text: error.response.data.message,
          })
          this.scrollTop()
          this.userButtonValidate = false
        })
        .finally(() => {
          this.scrollTop()
          this.confirmSMSPopUp = false
          this.userButtonSMSValidate = false
          this.validationCodeSMS = null
        })
    },

    openConfirmDeleteUserPopUp() {
      this.confirmDeleteUserPopUp = true
      this.userButtonDeleteAccount = true
    },

    closeConfirmDeleteUserPopUp() {
      this.confirmDeleteUserPopUp = false
      this.userButtonDeleteAccount = false

      if (this.doubleConfirmDeleteUserPopUp) {
        this.doubleConfirmDeleteUserPopUp = false
      }
    },

    openDoubleConfirmDeleteUserPopUp() {
      this.doubleConfirmDeleteUserPopUp = true
    },

    deleteAccountUser() {
      this.$router.push({ name: 'Login' })
    },

    closeAccountDeleteUserProcess() {
      this.confirmDeleteUserPopUp = false
      this.userButtonDeleteAccount = false
      this.doubleConfirmDeleteUserPopUp = false
    },

    enableDeleteAccountButton() {
      if (this.confirmDeleteAccountText === 'DELETE') {
        this.userButtonDoubleConfirmDeleteAccount = false
      } else {
        this.userButtonDoubleConfirmDeleteAccount = true
      }
    },

    disableUser() {
      this.messages = []
      services
        .disableUser(this.userID)
        .then((response) => {
          this.messages.push({
            status: 'success',
            text: this.$t('settings.security.messages.disable-user-success'),
          })

          this.scrollTop()
          let self = this
          setTimeout(() => {
            self.$router.push({ name: 'Login' })
          }, 4000)
        })
        .catch((error) => {
          this.scrollTop()
          this.closeAccountDeleteUserProcess()
          this.messages.push({
            status: 'danger',
            text: error.response.data.message,
          })
        })
    },
  },

  computed: {
    isValid() {
      return !this.$v.$invalid
    },

    optionsCountries() {
      return CallingCodeMoreFlag(this)
    },
  },
}
</script>

<style lang="scss" scoped>
.border-line {
  border-bottom: 2px solid #d1d4da;
}
</style>
